var api = require("!../../../../../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../node_modules/.pnpm/less-loader@7.3.0_less@3.13.1_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./styles.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};